module.exports = __webpack_public_path__ + "static/media/avaneq-glitch-big.10db0738.png";